module.exports = __webpack_public_path__ + "media/images/pc/brands/eight/store_nagoya-e743ad79c75ce082ec1171b113c914fc.jpg";